import axios from 'axios'

export const typesenseApi = axios.create({
  baseURL: `${process.env.REACT_APP_TYPESENSE_HOST}/collections/${process.env.REACT_APP_TYPESENSE_COLLECTION}/documents`,
})

typesenseApi.interceptors.request.use(config => {
  config.headers = {
    ...config.headers,
    'X-TYPESENSE-API-KEY': process.env.REACT_APP_TYPESENSE_API_KEY,
  }
  return config
})
